import React, { useEffect, useState } from 'react';
import {
    Badge,
    Button,
    Drawer,
    List,
    Space,
    Tag,
    Typography,
    message
} from 'antd';
import {
    CloudUploadOutlined,
    ReloadOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
    flushOutbox,
    outboxJobTitle,
    outboxTypeLabel,
    startOfflineQueueWatcher,
    subscribeOutbox
} from '../utils/installerOfflineQueue';
import { isInstallerNativeApp } from '../utils/installerSms';

const { Text } = Typography;

const InstallerOutboxBadge = () => {
    const [jobs, setJobs] = useState([]);
    const [open, setOpen] = useState(false);
    const [flushing, setFlushing] = useState(false);

    useEffect(() => {
        if (!isInstallerNativeApp()) {
            return undefined;
        }
        startOfflineQueueWatcher();
        return subscribeOutbox(setJobs);
    }, []);

    if (!isInstallerNativeApp()) {
        return null;
    }

    const count = jobs.length;

    const handleFlush = async () => {
        setFlushing(true);
        try {
            const result = await flushOutbox();
            if (result.flushed > 0) {
                message.success(
                    `Отправлено из очереди: ${result.flushed}`
                );
            } else if (count === 0) {
                message.info('Очередь пуста');
            } else if (!navigator.onLine) {
                message.warning(
                    'Нет интернета — очередь ждёт сеть'
                );
            } else {
                message.warning(
                    'Пока не удалось отправить. Повторим автоматически.'
                );
            }
        } finally {
            setFlushing(false);
        }
    };

    return (
        <>
            <Badge count={count} size="small">
                <Button
                    block
                    icon={<CloudUploadOutlined />}
                    onClick={() => setOpen(true)}
                    disabled={count === 0}
                >
                    Очередь отправки
                </Button>
            </Badge>

            <Drawer
                title="Очередь без сети"
                open={open}
                onClose={() => setOpen(false)}
                placement="bottom"
                height="70%"
            >
                <Space
                    direction="vertical"
                    style={{ width: '100%' }}
                    size={12}
                >
                    <Text type="secondary">
                        Здесь всё, что ещё не ушло на сервер:
                        SMS, VK, фото, выдача и передача ТМЦ.
                        Запись нельзя удалить, пока она не
                        отправится.
                    </Text>
                    <Button
                        type="primary"
                        icon={<ReloadOutlined />}
                        loading={flushing}
                        onClick={handleFlush}
                        block
                    >
                        Отправить сейчас
                    </Button>
                    <List
                        size="small"
                        dataSource={jobs}
                        locale={{
                            emptyText: 'Очередь пуста'
                        }}
                        renderItem={item => (
                            <List.Item>
                                <Space
                                    direction="vertical"
                                    size={2}
                                    style={{ width: '100%' }}
                                >
                                    <Space wrap>
                                        <Tag color="orange">
                                            Не отправлено
                                        </Tag>
                                        <Tag>
                                            {outboxTypeLabel(
                                                item.type
                                            )}
                                        </Tag>
                                        <Text type="secondary">
                                            {dayjs(
                                                item.createdAt
                                            ).format(
                                                'DD.MM HH:mm'
                                            )}
                                        </Text>
                                        {item.attempts ? (
                                            <Text type="secondary">
                                                попыток:{' '}
                                                {item.attempts}
                                            </Text>
                                        ) : null}
                                    </Space>
                                    <Text>
                                        {outboxJobTitle(item)}
                                    </Text>
                                    {item.lastError ? (
                                        <Text type="danger">
                                            {item.lastError}
                                        </Text>
                                    ) : null}
                                </Space>
                            </List.Item>
                        )}
                    />
                </Space>
            </Drawer>
        </>
    );
};

export default InstallerOutboxBadge;
